<template>
  <div class="toolbarWrapper">
    <el-form
      :inline="true"
      @submit.native.prevent
      size="small"
      class="comptoolbar"
      v-if="buttonList.length > 0"
    >
      <el-form-item v-if="selectBut">
        <el-input
          v-model="searchVal"
          :placeholder="$t('EnterContent')"
          size="small"
        ></el-input>
      </el-form-item>
      <slot name="before"></slot>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <template v-if="ShowButs">
        <el-form-item v-for="(item, index) in buttonList" :key="index">
          <!-- 这里触发点击事件 -->
          <el-button
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ field(item.name) }}</el-button
          >
        </el-form-item>
      </template>
      <el-form-item>
        <slot></slot>
      </el-form-item>
      <el-form-item class="toolbarAfter">
        <slot name="after"></slot>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "Toolbar",
  data() {
    return {
      searchVal: "", //双向绑定搜索内容
    };
  },
  props: {
    ShowButs: {
      type: Boolean,
      default: true,
    },
    buttonList: Array,
    selectBut: {
      type: Boolean,
      default: true,
    },
  }, //接受父组件传值
  methods: {
    callFunc(item) {
      item.search = this.searchVal;
      this.$emit("callFunction", item); //将值传给父组件
    },
  },
};
</script>